import './multi-store.css';

import { memo } from 'react';
import { Else, If, Then } from 'react-if';

import { DatePicker } from '../date-picker';
import { useAppSelector } from '../../../../store/hooks';
import { selectedIncludedPointOfSaleIds } from '../../../../store/multi-store';
import { MultiStoreDatePicker } from './multi-store-date-picker';
import { MultiStoreEntry } from './multi-store-entry';

// Step "quando" con lo Smart multi-store attivo (solo aziende FOCUS CLOUD): DatePicker
// classico invariato, con sotto l'invito a cercare negli altri centri, finché non si
// conferma almeno un centro ottico; poi calendario unificato, col riepilogo dei centri sopra
export const MultiStoreWhen = memo(function MultiStoreWhen(): JSX.Element {
  const includedIds = useAppSelector(selectedIncludedPointOfSaleIds);

  return (
    <If condition={includedIds.length > 1}>
      <Then>
        <MultiStoreDatePicker />
      </Then>
      <Else>
        <DatePicker />
        <MultiStoreEntry />
      </Else>
    </If>
  );
});
